/* eslint-disable @typescript-eslint/no-explicit-any */

import { isEmpty, toInteger } from 'es-toolkit/compat';

function formatModelValue(modelValue: string) {
  let viewValue: any = null;

  if (Number.isInteger(modelValue)) {
    if (toInteger(modelValue) < 0) {
      viewValue = '0';
    } else {
      viewValue = modelValue;
    }
  } else if (typeof modelValue === 'string') {
    viewValue = modelValue;
  }

  if ((viewValue == null) || Number.isNaN(viewValue)) {
    return '';
  }
  return viewValue;
}

function parseViewValue(allowEmpty: boolean): (viewValue: string) => string {
  const checkFn = allowEmpty ? isEmpty : ((v: unknown) => v == null);
  return (viewValue: string) => {
    let modelValue: any = null;

    if (!checkFn(viewValue)) {
      const parsed = toInteger(viewValue);
      if (!Number.isNaN(parsed)) {
        if (parsed < 0) {
          modelValue = 0;
        } else {
          modelValue = parsed;
        }
      }
    }

    if (modelValue == null) {
      return '';
    }

    return modelValue;
  };
}

/** Returns the parsed result of a number input form element. If the result is not a valid integer, returns 0. */
export function parseFormIntegerValueStrict(viewValue: string): number {
  if (!viewValue) {
    return 0;
  }

  const parsed = toInteger(viewValue);
  if (!Number.isFinite(parsed)) {
    return 0;
  }

  return parsed;
}

const numberFilter = {
  formatModelValue,

  parseViewValue: parseViewValue(false),

  formatOnChange: false,
};

export const integerOrEmpty = {
  formatModelValue,

  parseViewValue: parseViewValue(true),

  formatOnChange: false,
};

export default numberFilter;
